import * as Hammer from 'hammerjs';
import { NgModule } from '@angular/core';
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerModule, HammerGestureConfig } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';

import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';



import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { provideAnalytics, getAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { environment } from '../environments/environment';
import { AngularFireModule } from '@angular/fire/compat';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ShowListPageComponent } from './components/show-list-page/show-list-page.component';
import { DayButtonsListComponent } from './components/day-buttons-list/day-buttons-list.component';
import { DayButtonComponent } from './components/day-buttons-list/day-button/day-button.component';
import { ArrowLeftComponent } from './components/arrow-left/arrow-left.component';
import { ArrowRightComponent } from './components/arrow-right/arrow-right.component';
import { ProgramCardComponent } from './components/program-card/program-card.component';
import { PosterCardComponent } from './components/poster-card/poster-card.component';
import { HomePageComponent } from './components/home-page/home-page.component';
import { HeaderComponent } from './components/header/header.component';
import { HomeSliderComponent } from './components/home-slider/home-slider.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { HomeShowListComponent } from './components/home-show-list/home-show-list.component';
import { FooterComponent } from './components/footer/footer.component';
import { CloseButtonComponent } from './components/close-button/close-button.component';
import { SeriesChannelPageComponent } from './components/series-channel-page/series-channel-page.component';
import { WhereToWatchPageComponent } from './components/where-to-watch-page/where-to-watch-page.component';
import { MySwipeDirective } from './directives/my-swipe.directive';
import { SizzleOverlayComponent } from './components/sizzle-overlay/sizzle-overlay.component';
import { TopPromoComponent } from './components/top-promo/top-promo.component';
import { CmsLoginComponentComponent } from './components/cms/cms-login-component/cms-login-component.component';
import { FooterTrustarcComponent } from './components/footer-trustarc/footer-trustarc.component';
import { CmsLoginComponent } from './components/cms/cms-login/cms-login.component';
import { CmsStripComponent } from './components/cms/cms-strip/cms-strip.component';
import { VideoPlayPauseButtonComponent } from './components/video-play-pause-button/video-play-pause-button.component';
import { CircleComponent } from './components/circle/circle.component';
import { MovieSpherePlusPageComponent } from './components/movie-sphere-plus-page/movie-sphere-plus-page.component';
import { UpdatesPageComponent } from './components/updates-page/updates-page.component';
import { PosterBg3RowComponent } from './components/poster-bg-3row/poster-bg-3row.component';
import { PromoOverlayComponent } from './components/promo-overlay/promo-overlay.component';

export class MyHammerConfig extends HammerGestureConfig {
    // touchAction: 'auto',
    buildHammer(element: HTMLElement) {
        let mc = new Hammer(element, {
            touchAction: "pan-y",
            domEvents: true
        });
        return mc;
    }
    overrides = <any>{
        //   override hammerjs default configuration
        'swipe': { direction: Hammer.DIRECTION_HORIZONTAL },
        'pan': { direction: Hammer.DIRECTION_HORIZONTAL },
    }
}

@NgModule({
    declarations: [
        AppComponent,
        CircleComponent,
        ShowListPageComponent,
        DayButtonsListComponent,
        DayButtonComponent,
        ArrowLeftComponent,
        ArrowRightComponent,
        ProgramCardComponent,
        PosterCardComponent,
        HomePageComponent,
        HeaderComponent,
        SafeHtmlPipe,
        HomeSliderComponent,
        HomeShowListComponent,
        FooterComponent,
        CloseButtonComponent,
        SeriesChannelPageComponent,
        WhereToWatchPageComponent,
        MySwipeDirective,
        SizzleOverlayComponent,
        TopPromoComponent,
        CmsLoginComponentComponent,
        FooterTrustarcComponent,
        CmsLoginComponent,
        CmsStripComponent,
        VideoPlayPauseButtonComponent,
        MovieSpherePlusPageComponent
    ],
    imports: [
        UpdatesPageComponent,
        PosterBg3RowComponent,
        PromoOverlayComponent,
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        MatIconModule,
        MatDialogModule,
        MatButtonModule,
        MatInputModule,
        MatFormFieldModule,
        MatToolbarModule,
        MatCardModule,
        MatBottomSheetModule,
        DragDropModule,
        NgxMatDatetimePickerModule,
        NgxMatTimepickerModule,
        NgxMatMomentModule,
        MatDatepickerModule,
        MatCheckboxModule,
        MatNativeDateModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        ReactiveFormsModule,
        HttpClientModule,
        HammerModule,
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideAuth(() => getAuth()),
        provideFirestore(() => getFirestore()),
        provideStorage(() => getStorage()),
        AngularFireModule.initializeApp(environment.firebase)
    ],
    providers: [
        { provide: HAMMER_GESTURE_CONFIG, useClass: MyHammerConfig },
        ScreenTrackingService, UserTrackingService,
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
